import {AfterViewInit, Component, Input, OnChanges, OnInit} from '@angular/core';
import {getTransportIcon} from "../../../core/ult-functions/transport";
import {LocalizationService} from "../../../core/services/localization.service";

@Component({
  selector: 'app-transport-timeline',
  templateUrl: './transport-timeline.component.html',
  styleUrls: ['./transport-timeline.component.scss'],
})
export class TransportTimelineComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() transData: any[] | undefined;
  @Input() viewType: any;
  protected readonly getTransportIcon = getTransportIcon;
  localizationContent: any;

  transport: any[] = [];
  isShowMoreTab = false;
  isShowMoreToggled = false;

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {
    this.getLocalization(this.data.tour.language).then();
  }

  async getLocalization(lang: string): Promise<any> {
    this.localizationContent =
      await this.localizationService.getLocalizationContent(lang);
  }
  ngOnChanges(): void {
    if (Array.isArray(this.transData)) {
      this.transport = this.limitItemsOnMobileOrNot(this.transData);
    } else {
      this.transport = [];
    }
  }

  limitItemsOnMobileOrNot(transportArray: any): any[] {
    if (this.viewType === 'web'){
      return transportArray;
    }
    if (transportArray.length > 2) {
      this.isShowMoreTab = true;
      return transportArray.slice(0, 2);
    }
    return transportArray;
  }

  showMore(): void {
    this.isShowMoreToggled = !this.isShowMoreToggled;
    if (this.isShowMoreToggled) {
      this.isShowMoreTab = false;
      this.transport = this.transData as any[];
    }else{
      this.transport = this.limitItemsOnMobileOrNot(this.transData);
    }
  }
}
